import { RootState } from '../store';

export const selectSeniorityOptions = (state: RootState) => state.seniority.seniorityOptions;

export const selectSeniorityOptionsRequestStatus = (state: RootState) => state.seniority.seniorityOptionsRequestStatus;
